var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndeterminate = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 9,
  height: 9,
  viewBox: "0 0 9 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 9,
  rx: 2,
  fill: "#1072BA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 4.5H7",
  stroke: "white",
  strokeWidth: 0.75,
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndeterminate);
export { ForwardRef as ReactComponent };